/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SecondaryNav_accessibleTenants$ref: FragmentReference;
export type SecondaryNav_accessibleTenants = $ReadOnlyArray<{|
  +id: string,
  +url: ?string,
  +name: string,
  +$refType: SecondaryNav_accessibleTenants$ref,
|}>;
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "SecondaryNav_accessibleTenants",
  "type": "TenantType",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "url",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    }
  ]
};

(node/*: any*/).hash = 'ad15339e22511370c5050892bc85722a';
module.exports = node;
